import React from "react";
import { Box, Typography, Grid, Button } from "@mui/material";
import workings from "./../../assets/images/workings.png";
import { useTranslation } from "react-i18next";
import { navigateToFirstPage } from "../../utils/Utilities";
import { useNavigate } from "react-router-dom";
const Workings = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Box>
      <Box sx={{ textAlign: "center" }}>
        <Typography
        className="working-heading"
          mt={10}
          as={"h2"}
          fontSize={"3.8rem"}
          fontWeight="bold"
          color={"color.magentaDark2"}
          sx={{}}
        >
          {t("workings-h1")}
        </Typography>

        <Grid container mt={10}>
          <Grid item xs={12}>
            <Box>
              <img src={`/assets/images/${t("workings-img")}`} width="100%" />
            </Box>
          </Grid>
        </Grid>
        <Typography mt={8} fontSize={"1.38rem"} className="working-text">
          {t("workings-h2")}
        </Typography>
        <Button
        className="working-button"
          onClick={() => {
            navigateToFirstPage(navigate);
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: "smooth",
            });
          }}
          sx={{
            margin: "50px auto 60px auto",
            background: "#444660 ",
            fontSize: "1.3rem",
            color: "white",
            borderRadius: "7px",
            padding: "10px 20px",
            textTransform: "initial",
            fontWeight: "700",
            "&:hover": { background: "#00000010", color: "#444660" },
          }}
        >
          {t("workings-btn-text")}
        </Button>
      </Box>
    </Box>
  );
};

export default Workings;
